/**
 * The ONE way to open a Firestore listener in this app.
 *
 *   safeSnapshot(refOrQuery, next, { source, onError, snapshotOptions }) -> unsubscribe
 *
 * Every listener gets an error callback (before 2026-10-08, 18 of 31 had none, so a denied read
 * silently looked like "no data"). A rules denial is reported to the session-health guard
 * (src/services/sessionHealth.js), which heals the session or asks the user to sign in again —
 * it is never painted raw. Every error is logged and handed to the caller's
 * onError(err, { denied }) so a card can show "couldn't load" instead of an empty state.
 *
 * `source` is a short name for logs/LogRocket ("kanban/boards", "tasks/taggedWithPatient").
 * `snapshotOptions` is onSnapshot's optional options object ({ includeMetadataChanges }).
 *
 * Guardrail: cypress/node-tests/firestore-listen-guardrail.test.js fails on any `onSnapshot(`
 * call outside this file (escape hatch: a `raw-onsnapshot-ok: <reason>` comment on the line).
 */

import { onSnapshot } from 'firebase/firestore';
import { handleSnapshotError } from '@/services/sessionHealth';

export function safeSnapshot(refOrQuery, next, opts = {}) {
  const { source, onError, snapshotOptions } = opts;
  const error = (err) => handleSnapshotError(err, { source, onError, log: console.error });
  return snapshotOptions
    ? onSnapshot(refOrQuery, snapshotOptions, next, error) // raw-onsnapshot-ok: the wrapper itself
    : onSnapshot(refOrQuery, next, error); // raw-onsnapshot-ok: the wrapper itself
}
